import {
  LOADING_ARRAY,
  LIST_ALERT_RULES_REQUEST, LIST_ALERT_RULES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// unitId -> [alertRuleIds, ...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_ALERT_RULES_REQUEST:
      return {
        ...state,
        [action.unitId]: state[action.unitId] || LOADING_ARRAY,
      }
    case LIST_ALERT_RULES_RESPONSE:
      return {
        ...state,
        [action.unitId]: (action.rules || []).map((r) => r.id),
      }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
